var React = require('react');

function ZoomIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".zoom-icon-svg{fill:#fff;}")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("path",{"className":"zoom-icon-svg","d":"M4,1A3,3,0,1,1,1,4,3,3,0,0,1,4,1M4,0A4,4,0,1,0,8,4,4,4,0,0,0,4,0Z","key":0}),React.createElement("path",{"className":"zoom-icon-svg","d":"M6.85,6.35a.5.5,0,0,0-.35.15.51.51,0,0,0,0,.71L8.85,9.56a.51.51,0,0,0,.36.15.49.49,0,0,0,.35-.15.5.5,0,0,0,0-.71L7.21,6.5a.51.51,0,0,0-.36-.15Z","key":1})])]);
}

ZoomIcon.defaultProps = {"viewBox":"0 0 10 10"};

module.exports = ZoomIcon;

ZoomIcon.default = ZoomIcon;
